import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import styled, { css } from "styled-components"
import { media } from "utils/Media"
import ContainerMax from "components/shared/ContainerMax"

const HeroContainer = styled(ContainerMax)`
	position: relative;
	width: 100%;
	padding: 0;

	.background-gradient {
		background: ${props => props.theme.colors.gradientLeft};
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left :0;
		content: '';
		opacity: .75;
		z-index: 5;
	}
	h1 {
		color: ${props => props.theme.colors.secondary};
		font-family: ${props => props.theme.font.family.heading};
		////font-style: italic;
		line-height: .9;
		text-transform: uppercase;
		font-weight: 200;
		font-size: ${props => props.theme.font.size.xxl};
		
		@media ${media.md} {
			font-size: ${props => props.theme.font.size.xxl};
			padding-left: 75px;
			width: 80%;
			
		}
		@media ${media.xl} {
			padding-left: 85px;
			font-size: ${props => props.theme.font.size.xxxl};
		}
		@media ${media.xxl} {
			width: 80%;
		}
		z-index: 10;
		span {
			position: absolute;
			z-index: 0;
		}
	}
	.gatsby-image-wrapper {
		width: 100%;
		height: 100%;
	}
	img {
		pointer-events: none; 
	}
	`

const Title = styled.h1`
	position: absolute;
	top: calc(50%);
	transform: translateY(-50%);
	text-align: left;
	text-transform: uppercase;
	/* text-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8); */
	font-family: ${props => props.theme.font.family.heading};
	////font-style: italic;
	font-weight: ${props => props.theme.font.weight.bold};
	color: ${props => props.theme.colors.secondary};
	width: 100%;
	margin: 0;
	font-size: ${props => props.theme.font.size.xxl};
	padding: 0 1rem;
	@media ${media.md} {
		font-size: ${props => props.theme.font.size.xxxl};
	}
	@media ${media.lg} {
		left: calc(0% + 2.5%);
	}
	@media ${media.xl} {
		left: calc(0% + 5%);
	}
	@media ${media.xxl} {
		left: calc(0% + 10%);
	}
/* 
	@media ${media.sm} {
		font-size: 3.5rem;
	}

	@media ${media.md} {
		font-size: 3.5rem;
		top: calc(50% + 45px);
	}

	@media ${media.lg} {
		font-size: 4.5rem;
	}

	@media ${media.xl} {
		font-size: 5.5rem;
	}

	@media ${media.xxl} {
		font-size: 7.5rem;
	} */
`

const Hero = (props) => {
	const { block } = props
	const title = block.title ? block.title : props.pageTitle
	return(
		<HeroContainer noPadding maxWidth="1920">
			<div className="background-gradient" />
			{block.mobileImage &&
				<GatsbyImage 
					image={block.mobileImage.localFile.childImageSharp.gatsbyImageData} 
					alt={block.mobileImage.altText} 
					className="d-md-none"
				/>
			}
			{block.tabletImage &&
				<GatsbyImage 
					image={block.tabletImage.localFile.childImageSharp.gatsbyImageData} 
					alt={block.tabletImage.altText}
					className="d-none d-md-block d-lg-none"
				/>
			}
			{block.desktopImage &&
				<GatsbyImage 
					image={block.desktopImage.localFile.childImageSharp.gatsbyImageData} 
					alt={block.desktopImage.altText}
					className="d-none d-lg-block"
				/>
			}

			<Title>
				{title}
			</Title>
		</HeroContainer>
  )
}

export default Hero